import { registerCustomElement } from '../utils.mjs';
import { markdown } from '../markdown.mjs';

export class Markdown extends HTMLElement {
	/**
	 * Builds the separator dom.
	 *
	 * @param instructions {object} Collection of directives.
	 */

	async build(instructions) {
		this.setAttribute('name', instructions.name || '');
		this.className = 'form-group';
		this.innerHTML = markdown(instructions.label);
	}
}

// TODO: deprecated - will be removed
registerCustomElement('imt-input-markdown', class extends Markdown {});
registerCustomElement('imt-visual-markdown', Markdown);
